import { cssModuleClassNames } from '@carlito/css';
import styles from '../index.module.css';
import cn from 'classnames';
import { PropsWithChildren } from 'react';

const { getCssModuleClassName } = cssModuleClassNames(styles);
export type ModalProps = PropsWithChildren<{
  onCloseModal: () => void;
}>;

export default function Modal({ children, onCloseModal }: ModalProps) {
  return (
    <>
      <div className="bookito-widget__modal justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative  w-full my-6 max-w-[70rem] h-full max-h-[95%]">
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full !bg-light-default outline-none focus:outline-none mb-10">
            <button className="ml-auto mr-5 mt-2 font-extrabold text-lg" onClick={onCloseModal}>
              X
            </button>
            <div
              className={cn(
                'max-h-[80vh] overflow-y-auto relative',
                getCssModuleClassName('custom-scrollbar')
              )}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25  fixed inset-0 z-40 bg-black"></div>
    </>
  );
}
